module.exports = "<ag-grid-angular\r\n  [rowData]=\"gridData\"\r\n  [gridOptions]=\"gridComplaintResponses\">\r\n</ag-grid-angular>\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/grid-complaints-responses/grid-complaints-responses.component.html
// module id = 2614
// module chunks = 66